import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import BoardOfAdvisors from "@/pages/BoardOfAdvisors";

export const Route = createFileRoute("/en/about-qbd/board-of-advisors")({
  head: () => buildRouteHead("/en/about-qbd/board-of-advisors"),
  component: BoardOfAdvisors,
});

